export function getJWPlayer() {
  return typeof window !== "undefined" ? window.jwplayer?.() : undefined;
}

export function pauseJWPlayer() {
  const player = getJWPlayer("player-1");
  if (player && player.pause) {
    player.pause();
    player.pauseAd();
  }
}
